import React, { useState } from "react";
import { withFeatureSafe } from 'Common/ErrorBoundaries';
import CrossIcon from "SVGS/CrossIcon";
import TickIcon from "SVGS/TickIcon";

const PasswordTooltipWrapper = ({ children, extraClass, value }) => {
    const [touched, setTouched] = useState(false);

    const validations = [
        { id: 1, check: (pw) => /[a-z]/.test(pw), message: "Contains small letter" },
        { id: 2, check: (pw) => /[A-Z]/.test(pw), message: "Contains capital letter" },
        { id: 3, check: (pw) => /\d/.test(pw), message: "Contains number" },
        { id: 4, check: (pw) => /[\W_]/.test(pw), message: "Contains special character" },
        { id: 5, check: (pw) => pw.length >= 6, message: "Minimum 6 characters" },
    ];

    const failedValidations = validations.filter(v => !v.check(value));
    const isValid = failedValidations.length === 0;

    return (
        <div className="relative " >
            <div
                onFocus={() => setTouched(true)}
                onBlur={() => setTouched(false)}
                data-tooltip-id="password-tooltip"

            >
                {children}
            </div>
            {touched && <div
                className={`w-80 after: z-10 right-full top-1/2 transform -translate-y-1/2 h-auto pr-4 transition-opacity duration-300 ease-in-out
                    } ${extraClass || "absolute"}`}
            >
                <ul className={` z-[9999] text-sm bg-white border  p-4 rounded-lg
                 after:w-4 after:h-4 after:bg-white after:absolute after:right-[7px] after:top-14 after:rotate-45
                  after:z-0 after:border-r after:border-t  ${!isValid ? "border-red-700 after:border-t-red-700 after:border-r-red-700" : "border-[#006600] after:border-t-[#006600] after:border-r-[#006600]"}`}>
                    {validations.map((v) => (
                        <li key={v.id} className={`flex gap-2`}>
                            <span>
                                {v.check(value) ? <TickIcon color="#006600" /> : <span className="text-red-700"><CrossIcon /></span>}

                            </span>
                            {v.message}
                        </li>
                    ))}
                </ul>
            </div>}
        </div>
    );
};

export default withFeatureSafe(PasswordTooltipWrapper);